// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"5942":"771c4b6d653d11a0","6770":"b66c4806eb00c141"}[chunkId] + ".css";
};